const STELLAIR_APP_URL = process.env.REACT_APP_STELLAIR_APP_URL
const STELLAIR_REDIRECT_URI = `${process.env.REACT_APP_BASE_URL}/stellair/oauth2/redirect`
const STELLAIR_CLIENT_ID = process.env.REACT_APP_STELLAIR_CLIENT_ID
const STELLAIR_AUTHORIZE_URL = process.env.REACT_APP_STELLAIR_AUTHORIZE_URL

export { STELLAIR_APP_URL, STELLAIR_CLIENT_ID, STELLAIR_AUTHORIZE_URL, STELLAIR_REDIRECT_URI }
